<edu-layout-standard-page [header]="'routes.internal.dashboard.title' | transloco">
  <!-- Welcome Section -->
  <div class="bg-card border-line mb-8 rounded-2xl border p-6">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between">
      <div class="mb-4 lg:mb-0">
        <h2
          class="text-fg mb-2 text-2xl font-semibold"
          [innerHTML]="
            'routes.internal.dashboard.welcome.header'
              | transloco: { firstname: welcomeFirstname() }
          "
        ></h2>
        <p
          class="text-fg-muted text-lg"
          [innerHTML]="'routes.internal.dashboard.welcome.description' | transloco"
        ></p>
      </div>
      <div class="flex flex-col gap-3 sm:flex-row">
        <edu-button (click)="openNewFeaturesGuide()">
          {{ 'routes.internal.dashboard.welcome.actions.viewGuide' | transloco }}
        </edu-button>
      </div>
    </div>
  </div>

  <!-- Upcoming Features Section -->
  <div class="mb-8">
    <h3 class="text-fg mb-6 text-xl font-semibold">
      {{ 'routes.internal.dashboard.newFeatures.title' | transloco }}
    </h3>
    <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      <!-- Improved Dashboard -->
      <div class="bg-card border-line rounded-2xl border p-6">
        <div class="bg-primary/10 text-primary mb-4 inline-flex rounded-lg p-3">
          <edu-icon [icon]="Icons.BETA" />
        </div>
        <h4 class="text-fg mb-2 text-lg font-semibold">
          {{ 'routes.internal.dashboard.newFeatures.dashboard.title' | transloco }}
        </h4>
        <p class="text-fg-muted mb-4 text-sm">
          {{ 'routes.internal.dashboard.newFeatures.dashboard.description' | transloco }}
        </p>
        <a
          class="text-primary hover:text-primary-hover text-sm font-medium"
          href="https://edudip.com/blog-das-neue-edudip-dashboard/"
          target="_blank"
        >
          {{ 'routes.internal.dashboard.newFeatures.dashboard.cta' | transloco }} →
        </a>
      </div>

      <!-- Monetization -->
      <div class="bg-card border-line rounded-2xl border p-6">
        <div class="bg-success/10 text-success mb-4 inline-flex rounded-lg p-3">
          <edu-icon [icon]="Icons.MONETIZATION" />
        </div>
        <h4 class="text-fg mb-2 text-lg font-semibold">
          {{ 'routes.internal.dashboard.newFeatures.paidWebinars.title' | transloco }}
        </h4>
        <p class="text-fg-muted mb-4 text-sm">
          {{ 'routes.internal.dashboard.newFeatures.paidWebinars.description' | transloco }}
        </p>
        <a
          class="text-primary hover:text-primary-hover text-sm font-medium"
          href="https://edudip.com/blog-bezahlte-webinare-mit-edudip/"
          target="_blank"
        >
          {{ 'routes.internal.dashboard.newFeatures.paidWebinars.cta' | transloco }} →
        </a>
      </div>

      <!-- Webinar Templates -->
      <div class="bg-card border-line rounded-2xl border p-6">
        <div class="bg-info/10 text-info mb-4 inline-flex rounded-lg p-3">
          <edu-icon [icon]="Icons.CUSTOMIZED" />
        </div>
        <h4 class="text-fg mb-2 text-lg font-semibold">
          {{ 'routes.internal.dashboard.newFeatures.webinarTemplates.title' | transloco }}
        </h4>
        <p class="text-fg-muted mb-4 text-sm">
          {{ 'routes.internal.dashboard.newFeatures.webinarTemplates.description' | transloco }}
        </p>
        <a
          class="text-primary hover:text-primary-hover text-sm font-medium"
          href="https://edudip.com/blog-webinarvorlagen/"
          target="_blank"
        >
          {{ 'routes.internal.dashboard.newFeatures.webinarTemplates.cta' | transloco }} →
        </a>
      </div>
    </div>
  </div>

  <!-- Support Section -->
  <div class="bg-card border-line rounded-2xl border p-6">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between">
      <div class="mb-4 lg:mb-0">
        <h3 class="text-fg mb-2 text-xl font-semibold">
          {{ 'routes.internal.dashboard.support.title' | transloco }}
        </h3>
        <p class="text-fg-muted">
          {{ 'routes.internal.dashboard.support.description' | transloco }}
        </p>
      </div>
      <div class="flex flex-col gap-3 sm:flex-row">
        <edu-button variant="secondary" (press)="contactSupport()">
          {{ 'routes.internal.dashboard.support.actions.contactSupport' | transloco }}
        </edu-button>
      </div>
    </div>
  </div>
</edu-layout-standard-page>
